import { makeStyles } from '@material-ui/core/styles';
export const useStyles = makeStyles((theme) => ({
    index_logo: { height: '44px', display: 'flex', alignItems: 'center' },
    header: {
        gap: '30px',
        width: '100%',
        height: '72px',
        display: 'flex',
        padding: '14px 20px',
        background: '#fff',
        flexDirection: 'row',
        boxShadow: '0px 4px 32px 0px rgba(0, 0, 0, 0.15)'
    },
    sticky: {
        position: 'sticky',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 10
    },
    sub_header: {
        zIndex: 9,
        gap: '8px',
        top: '72px',
        color: '#fff',
        height: '47px',
        display: 'flex',
        fontSize: '16px',
        paddingTop: '12px',
        alignSelf: 'center',
        textAlign: 'center',
        flexDirection: 'row',
        background: '#3E15D7',
        justifyContent: 'center',
        borderRadius: '0 !important',
        fontFamily: 'Poppins-Medium',
        '&:hover': { color: '#fff', opacity: 0.8 },
        [theme.breakpoints.up('sm')]: { display: 'none' }
    }
}));
//# sourceMappingURL=style.js.map